<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Cookies" />
            <CooKie />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import CooKie from '../MentionLegale/CooKie'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'CooKiePage',
    components: {
        NavBar,
        PageTitle,
        CooKie,
        FooterComp,
    }
}
</script>